/**
 * BillingCancel — user backed out of Stripe Checkout. No charge, no harm.
 */
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, RotateCcw } from 'lucide-react';

export default function BillingCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#0A0A0A' }} data-testid="billing-cancel-page">
      <div className="max-w-lg w-full text-center">
        <div className="font-hud text-[10px] tracking-widest uppercase text-white/55 mb-2">Checkout cancelled</div>
        <div className="font-historical text-3xl md:text-5xl text-[#D4A84A] leading-tight">No charge.</div>
        <p className="font-mono text-sm md:text-base text-white/65 mt-3 max-w-md mx-auto">
          You backed out of the Beta Pass checkout. That's fine — your seat in the network
          waits for whenever you're ready. Methodology hold #5: calmer head than you came in with.
        </p>
        <div className="flex items-center justify-center gap-3 mt-7">
          <button
            onClick={() => navigate('/billing')}
            data-testid="billing-cancel-retry-btn"
            className="font-hud text-xs tracking-widest text-[#0A0A0A] bg-[#D4A84A] px-5 py-3 hover:bg-[#D4A84A]/85 inline-flex items-center gap-2"
          >
            <RotateCcw size={12} /> TRY AGAIN
          </button>
          <button
            onClick={() => navigate('/')}
            className="font-hud text-xs tracking-widest text-white/85 border border-[#D4A84A]/40 px-5 py-3 hover:text-[#D4A84A] inline-flex items-center gap-2"
          >
            <ArrowLeft size={12} /> HOME
          </button>
        </div>
      </div>
    </div>
  );
}
